import styled from "styled-components";
import { IconKey } from "../../models/client";
import Icon from "../Icon";
import { Pill } from "../Pill";

interface LongCursorProps {
  icon?: IconKey;
}

const Wrapper = styled.div`
  position: absolute;
  left: -32px;
  top: -32px;
`;

const IconContainer = styled.div`
  /* position: absolute; */

  height: 100%;
  width: 24px;
  line-height: 1;
  /* transform: translateY(-50%); */

  svg {
    /* position: relative;
    top: auto;
    height: 24px;
    width: 24px; */
    right: 0;
  }
`;

export const LongCursor: React.FC<LongCursorProps> = ({
  icon = "add",
  children,
}) => {
  return (
    <Wrapper>
      <Pill>
        <IconContainer>
          <Icon icon={icon} />
        </IconContainer>
        {children}
      </Pill>
    </Wrapper>
  );
};
